import { render, staticRenderFns } from "./SkuItem.vue?vue&type=template&id=a927dff0&scoped=true&"
import script from "./SkuItem.vue?vue&type=script&lang=ts&"
export * from "./SkuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SkuItem.scss?vue&type=style&index=0&id=a927dff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a927dff0",
  null
  
)

export default component.exports